import { INITIAL_USER } from '../../utils/constants';

export default function () {
  return {
    email: undefined,
    user: { ...INITIAL_USER },
    loadingUser: false,
    savingUser: false,
    userOrganisations: [],
    loadingUserOrganisations: false,
    savingUserOrganisation: false,
    ORGBranding: {}
  };
}
